export const environment = {
  production: true,
  jsonConfig: 'config.json'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts